export { default } from './tooltip';
export { default as TooltipPrimitive } from './tooltip-primitive';
export type { TooltipPrimitiveProps } from './tooltip-primitive';
export type { PositionType, TooltipProps, TriggerProps } from './types';
